import axios from 'axios';

class SiteHeader {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-siteheader',
            eventScroller: null,
            scrollOffset: 50,
            onCartLoaded: null
        };

        this.settings = Object.assign({}, defaults, options);

        this.$siteHeader = element;
        this.eventScroller = this.settings.eventScroller;

        this.initialize();
    }

    initialize () {
        this.setEvents();
        this.getMinicart();
        this.getConfiguratorState();
    }

    checkHeaderPosition () {
        if (this.eventScroller) {
            const scrollInfo = this.eventScroller.getScrollInfo();
            const currentScrollPosition = scrollInfo.position;
            const currentScrollDirection = scrollInfo.direction;

            if (currentScrollPosition >= this.settings.scrollOffset) {
                this.$siteHeader.classList.add('is--fixed');

                if (currentScrollDirection === 'up') {
                    this.$siteHeader.classList.add('is--visible');
                } else {
                    this.$siteHeader.classList.remove('is--visible');
                }
            } else {
                this.$siteHeader.classList.remove('is--fixed');
                this.$siteHeader.classList.remove('is--visible');
            }
        }
    }

    setEvents () {
        if (this.eventScroller) {
            this.eventScroller.customFunctions.push(() => {
                this.checkHeaderPosition();
            });
            this.checkHeaderPosition();
        }
    }

    getMinicart () {
        const $url = this.$siteHeader.getAttribute('data-minicart');
        const $minicartWrapper = this.$siteHeader.querySelector('[data-minicart-ajax="root"]');

        if (typeof $minicartWrapper !== 'undefined' && $minicartWrapper !== null) {
            axios({
                url: $url
            })
                .then((response) => {
                    const div = document.createElement('div');
                    div.innerHTML = response.data.content;
                    $minicartWrapper.append(div);

                    if (typeof this.settings.onCartLoaded === 'function') {
                        this.settings.onCartLoaded($minicartWrapper);
                    }
                })
                .then((response) => {
                    if (response !== undefined) {
                        const div = document.createElement('div');
                        div.innerHTML = response.data.content;
                        $minicartWrapper.append(div);
                    }
                })
                .catch((error) => {
                    throw Error(error);
                });
        }
    }

    getConfiguratorState () {
        const $buyNowButtonContainer = this.$siteHeader.querySelector('[data-badge]');

        if ($buyNowButtonContainer !== null) {
            const $buyNowButton = $buyNowButtonContainer.querySelector('a');
            const $url = $buyNowButtonContainer.getAttribute('data-badge');

            axios({
                url: $url
            })
                .then((response) => {
                    if (!response.data.has_configuration) {
                        return false;
                    } else {
                        $buyNowButton.classList.add('is--active');
                    }
                })
                .catch((error) => {
                    throw Error(error);
                });
        }
    }
}

export { SiteHeader };
